// extracted by mini-css-extract-plugin
export default {"modal-header":"AddDocument_modal-header__ykinc","modal-header-filter":"AddDocument_modal-header-filter__MNsnx","modal-title":"AddDocument_modal-title__rT740"};